import React, { useState, lazy, Suspense } from 'react';
import cn from 'classnames';
import style from './login.module.scss';
import Ringtone from '@assets/tones/beep-08b.mp3';
import { playRingtone, safeJsonParse } from '@utility/helperFunction';
import Modal from '@components/common/Modal';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import { flowType } from '../../utility/userInfo';
import { ReactComponent as BackChevron } from '@assets/images/backChevron.svg';
import Loader from '../common/Loader/newLoaderModal';
const LoginScreenKeyboard = lazy(() =>
  import('@components/common/formElements/SimpleKeyboard/loginScreenKeyboard')
);

const Login = props => {
  const {
    version,
    deviceName,
    nativeAppVersion,
    onLoginClick,
    validateLogin,
    storePhoneNumber,
    handleActivateRoute,
    serverAppTheme,
    auth,
    isOrderingPortrait,
  } = props;  

  const [reactivateConfirm, setReactivateConfirm] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const isServerApp = flowType() === 'serverApp';
  const deviceInfo = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {});
  
  const confirmationReactivatePopUp = () => {
    setReactivateConfirm(true);
  };

  const renderFormText = () => {
    const openCardPopUp = () => {
      playRingtone(Ringtone);
      props.initializeIngenico();
      props.setIsSwipe(true);
    };
    const lastRebootDate = () => {
      const lastRebootOn = window.sessionStorage.getItem('lastRebootOn');
      if (
        lastRebootOn == null ||
        lastRebootOn == undefined ||
        lastRebootOn == 'null' ||
        lastRebootOn == 'undefined'
      ) {
        return null;
      } else {
        const today = new Date(lastRebootOn);
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();
        let HH = today.getHours();
        let minutes = today.getMinutes();
        var sAMPM = 'AM';

        var iHourCheck = parseInt(HH);

        if (iHourCheck > 12) {
          sAMPM = 'PM';
          HH = iHourCheck - 12;
        } else if (iHourCheck === 0) {
          HH = '12';
        }
        const formattedToday =
          mm +
          '/' +
          dd +
          '/' +
          yyyy +
          ' ' +
          (Number(HH) > 9 ? HH : '0' + HH) +
          ':' +
          (Number(minutes) > 9 ? minutes : '0' + minutes) +
          ' ' +
          sAMPM;
        return formattedToday;
      }
    };

    return (
      <div
        className={cn('h-100')}
        style={{
          background: serverAppTheme?.background_color,
          color: serverAppTheme?.primary_text,
        }}
      >
        <div className={cn('col-12 mx-0 p-0 h-89')}>
          {!window.ReactNativeWebView && (
            <div
              className={cn(
                'position-fixed justify-content-center align-items-center rounded d-flex',
                style.deactivateIcon,
                style.loginTextPrimary
              )}
              role="presentation"
              onClick={() => confirmationReactivatePopUp()}
              style={{ backgroundColor: serverAppTheme.iconcolor_bg_box }}
            >
              <BackChevron
                fill={props.serverAppTheme?.iconcolor}
                alt=""
                aria-hidden="true"
              />
            </div>
          )}
          <div
            className={cn(
              'col-12 w-100',
              props.isKiosk
                ? 'col-md-12 h-25  pt-3'
                : props.desktopImage
                ? 'pr-0 col-md-12 h-25 pt-3'
                : 'pr-0 col-md-12 h-18 pt-3'
            )}
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div
              className={cn(
                'col-12 col-md-12 p-0 mx-0 fs-12 flex-nowrap justify-content-center h-100'
              )}
            >
              <div
                className={cn(
                  'p-0 row m-auto align-items-center col-4 col-md-4'
                )}
              >
                {props.desktopImage && (
                  <img
                    src={props.desktopImage}
                    className="img-fluid mx-auto d-block"
                    alt="Login Logo"
                    loading="lazy"
                    style={{ height: '4.94rem', width: '12.1rem;' }}
                  />
                )}
              </div>
              <div
                className={cn(
                  'col-5 my-1 p-0 m-auto text-center justify-content-center ',
                  !props.desktopImage && 'h-100 d-flex align-items-end'
                )}
              >
                <div className="fs_16 ">{auth.name}</div>
              </div>
            </div>
          </div>
          <div
            className={cn(
              'col-12  py-2 h-90 mx-auto',
              props.isKiosk ? 'col-md-12' : 'col-md-8 px-3 h-74'
            )}
          >
            <Suspense fallback={<Loader />}>
              <LoginScreenKeyboard
                containerClass={cn(
                  'mx-0 justify-content-center align-items-start h-100 my-0'
                )}
                type="number"
                name="loginKeyboard"
                validate={validateLogin}
                buttonName={
                  props.isKiosk
                    ? LABEL().KIOSK_LOGIN
                    : !deviceInfo?.deviceGroup?.serverAppSettings
                        ?.enableLoginWithCard &&
                      deviceInfo?.deviceGroup?.serverAppSettings
                        ?.disableLoginWithKeypad
                    ? ''
                    : deviceInfo?.deviceGroup?.serverAppSettings
                        ?.disableLoginWithKeypad
                    ? LABEL().CLICK_TO_SWIPE_CARD
                    : LABEL().LOGIN
                }
                placeholder={CUSTOM_MESSAGES().ENTER_EMPLOYEE_CODE}
                onSubmit={onLoginClick}
                goToSwiper={() => openCardPopUp()}
                isSwipe
                hide={isServerApp}
                isKioskMode={props.isKiosk}
                auth={auth}
                setLoginError={setLoginError}
                serverAppTheme={serverAppTheme}
                aria-label="Enter your login credentials"
                aria-required="true"
                isOrderingPortrait={isOrderingPortrait}
              />
            </Suspense>
          </div>
        </div>
        {
          <div>
            <div
              className={cn(
                'col-12 col-md-12 h-8 align-items-end row mx-0 fs-14 pt-2',
                !isOrderingPortrait ? "px-4" : "px-2"
              )}
            >
              <div
                className={cn(
                  'col-12 col-md-12 mt-0',
                  !isOrderingPortrait ? 'text-center px-0' : 'text-right',
                  style.support,
                  !isOrderingPortrait ? "" : style.portrait_support_pos
                )}
                style={{
                  whiteSpace: 'pre-wrap',
                  color: serverAppTheme?.contact_support,
                }}
              >
                {LABEL().FOR_SUPPORT}, {LABEL().CONTACT}
                {'\n'}
                <span style={{ fontSize: '18px', lineHeight: '21px' }}>
                  {storePhoneNumber}
                </span>
              </div>
              <div
                className={cn(
                  style.systemsInfo,
                  'col-12 text-left h-10',
                  props.isKiosk ? 'col-md-6' : 'col-md-7',
                  !isOrderingPortrait ? style.landscape_systemsInfo_pos : style.portrait_systemInfo_pos
                )}
              >
                {deviceName} App {`v${nativeAppVersion}`} | Web {`v${version}`}
                {'\n'}
                {/* <p>Last Reboot On {lastRebootDate()}</p> */}
              </div>
            </div>
          </div>
        }
        {props.isSwipe && (
          <Modal
            isOpen={props.isSwipe}
            isModalCenter
            style={{
              backgroundColor: serverAppTheme?.popUp_bg,
              borderRadius: '16px',
            }}
            aria-labelledby="modal-title"
            aria-hidden={props.isSwipe ? 'false' : 'true'}
            noBackground
          >
            <div
              className="mb-0"
              style={{
                color: serverAppTheme.primary_text,
                border: '1px solid #9F9F9F',
                borderRadius: '16px',
              }}
            >
              <div className="col-12 fs_18 fw-400 mt-20 mb-20 justify-content-center align-items-center text-center">
                Please swipe the card after the beep
              </div>
              <div className="col-12 fs_20 fw-700 mb-20 justify-content-center align-items-center text-center">
                <button
                  aria-label="Cancel"
                  className={cn(style.secondary_btn)}
                  type="button"
                  onClick={() => {
                    props.setIsSwipe(false);
                    props.handleStopMagneticRead();
                  }}
                >
                  {LABEL().CANCEL}
                </button>
              </div>
            </div>
          </Modal>
        )}
        {reactivateConfirm && (
          <Modal
            isOpen={reactivateConfirm}
            style={{
              backgroundColor: serverAppTheme?.popUp_bg,
              borderRadius: '16px',
              border: serverAppTheme?.popupBorder,
              boxShadow: serverAppTheme?.popUp_box_shadow,
            }}
            isModalCenter
            customClass3={cn(style.reActivatePop)}
          >
            <div
              className="col-12 my-4 row mx-0"
              style={{ color: serverAppTheme?.primary_text }}
            >
              <div className="col-12 py-2 fw-600 text-center">
                {CUSTOM_MESSAGES().REACTIVATE_WITH_NEW_CODE}
              </div>
              <div className="col-6">
                <button
                  aria-label="No"
                  className={cn('btn w-100 btn44')}
                  style={{
                    border: serverAppTheme?.cancleBtn_Border,
                    background: serverAppTheme?.OFF_Premise_Btn,
                    color: serverAppTheme?.cancleBtn_font,
                  }}
                  type="button"
                  onClick={() => {
                    setReactivateConfirm(false);
                  }}
                >
                  {LABEL().NO}
                </button>
              </div>
              <div className="col-6">
                <button
                  aria-label="Yes"
                  type="button"
                  style={{
                    backgroundColor: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                    borderRadius: '8px',
                    border: `1px solid ${serverAppTheme.secondaryBtn}`,
                    height: '8.5vh',
                  }}
                  className={cn('btn w-100 btn-ripple btn44')}
                  onClick={handleActivateRoute}
                >
                  {LABEL().YES}
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  };
  return <>{renderFormText()}</>;
};

export default React.memo(Login);
